import React from "react";
import { Alert, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import ImageWithDescription from "../../Components/ImageWithDescription";
const { Title } = Typography;

export const PicoLBE = () => {
  return (
    <div style={{ maxWidth: 900, background: "#ffffff0d", padding: 30 }}>
      <Title>Pico LBE Setup</Title>
      <Alert
        message="Pico LBE/ Map Sharing"
        description={
          <>
            Create a map with one headset and share it with your other headsets.
            This means you no longer need to calibrate your headsets.
          </>
        }
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />
      <section>
        <Title level={2}>Requirements</Title>
        <ol>
          <li>
            LBE Mode only supports Pico 4 Ultra Enterprise headsets and Pico 4
            Enterpise headsets
          </li>
          <li>
            The Hero Zone background service must be installed and running on
            the headset. (reinstalling the games on your headsets will install
            and start the background service)
          </li>
        </ol>
      </section>

      <section>
        <Title level={2}>Map creation</Title>
        <ol>
          <li>
            Navigate to the Pico LBE tab in the launcher settings and click on
            the &quot;Create New Map&quot; button.
            <ImageWithDescription
              width={800}
              src="/images/manual/picoLBE/createMap1.jpg"
              description="Click on Create Map"
            />
          </li>
          <li>
            Choose a headset to create your map with.
            <ImageWithDescription
              width={800}
              src="/images/manual/picoLBE/createMap2.jpg"
              description="Choose a headset to create your map with"
            />
          </li>
          <li>
            Export the map
            <ImageWithDescription
              width={800}
              src="/images/manual/picoLBE/createMap3.jpg"
              description="Export the map"
            />
          </li>
          <li>
            The map should now be created and ready to use. The other headsets
            will automatically import the map when they connect to the launcher.
            <ImageWithDescription
              width={800}
              src="/images/manual/picoLBE/createMap4.jpg"
              description="The map should now be created and ready to use"
            />
          </li>
        </ol>
      </section>

      <section>
        <Title level={2}>Import Map</Title>
        <p>
          If the LBE Mode setting and Map sharing settings are both enabled, the
          map should automatically be imported by all the headsets.
        </p>
        <p>
          Note that the Hero Zone Background Service needs to be running on the
          headset and be connected with the launcher. The easiest way to ensure
          this is to reinstall the games on the headset.
        </p>
        <p>
          When the map is successfully imported, the &quot;current Map&quot;
          field will be updated
        </p>
      </section>
      <section>
        <Title level={2}>Headset Actions</Title>
        <ul>
          <li>
            <b>Clear Map</b>: Clear the current map from the headset. The
            headset will exit LBE mode.
          </li>
          <li>
            <b>Reimport Map</b>: Reimport the current map from the launcher.
            This is useful if there are any issues with the map for a specific
            headset.
          </li>
          <li>
            <b>Start Map Creation</b>: Manually trigger the map creation
            process, instead of using the &quot;create new map&quot; flow
          </li>
          <li>
            <b>Export Map</b>: Export the current map to the launcher, skipping
            the &quot;create new map&quot; flow
          </li>
        </ul>
        <ImageWithDescription
          width={800}
          src="/images/manual/picoLBE/actions.jpg"
          description="Headset Actions"
        />
      </section>
      <section>
        <Title level={2}>FAQ</Title>

        <ul>
          <div>
            <Title level={3}>Using other software for map sharing</Title>
            <p>
              If you wish to use other software to implement map sharing, make
              sure the "Pico LBE Mode" option is enabled and "Map Sharing" is
              disabled.
            </p>
          </div>
          <div>
            <Title level={3}>Exiting LBE Mode</Title>
            <p>
              If the headset malfunctions or is taken to another location where
              it cannot regain positioning, you can quickly exit LBE mode by
              pressing the volume up and down buttons in a specific sequence.
              The sequence is ++--++-- (complete within 3 seconds).
            </p>
          </div>
          <div>
            <Title level={3}>Map not importing on other headsets</Title>
            <p>
              The map can only be imported if the headset is connected to the
              launcher. The connection status should be green in the headset
              list in the Pico LBE tab. If the status is red, try connecting the
              headset to the PC with a USB cable and check the result of the
              diagnose tab.
            </p>
          </div>
        </ul>
      </section>
    </div>
  );
};
